import { Component, Input, Output, EventEmitter, OnInit, Pipe, PipeTransform } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { ToastrService } from "ngx-toastr";
import { Permission } from "src/app/Login/_guards/Permission";
import { ApiPathsService } from "src/app/api-paths.service";
import { environment } from "src/environments/environment";

@Component({
    selector: 'app-categorie-list',
    templateUrl: './categorie-list.component.html'
  })
  export class CategorieListComponent implements OnInit {
    @Input() HasAdd: boolean = true;
    @Input() Categorie: any[];
    @Output() CategorieChange = new EventEmitter<any>(); 
    @Input() CatFull: any[];
    @Output() CatFullChange = new EventEmitter<any>(); 
    @Input() sel_cat_id: number;
    @Output() sel_cat_idChange = new EventEmitter<number>(); 
    @Input() Capacita: string[] = []; 
    @Input() EditModal: NgbModal;
    @Output() DeleteClick= new EventEmitter<any>();
    @Input() Sublist: boolean = true;
    @Input() modificheAbilitate: boolean = false;
    @Output() modificheAbilitateChange = new EventEmitter<any>(); 
    @Output() Navigate = new EventEmitter<any>();
    @Output() Refresh = new EventEmitter<any>();
    @Output() Save = new EventEmitter<any>();
    @Input() Tipo: string;
    @Input() Sources = [];

    Env = environment;
    categoriedropdownSettings: IDropdownSettings = {
      singleSelection: true,
      closeDropDownOnSelection: true,
      textField: 'categoria',
      searchPlaceholderText: "inserire almeno 3 caratteri",
      allowSearchFilter: true,
      allowRemoteDataSearch: true,
    };
   
    CategoriaDaModificare: any = null;
    LabelCategoria: string = "";
    showMenu = '';
    showSubMenu = '';
    
    CategorieLineare: any[] = [];
    CategorieSelezionate: any[] = [];
    Ordine: number;
    constructor(
        public permission: Permission,
        private modalService: NgbModal,
        private toastService: ToastrService,
        public apiPaths: ApiPathsService,
        private route: ActivatedRoute
    ){}
    ngOnInit(){
        this.route.params.subscribe(data => {
            this.Tipo = data['type']; 
            console.log("Url Data: ", data);
            this.RefreshList();
          })
    }
    AbilitaModifiche() {
        this.modificheAbilitate = !this.modificheAbilitate;
        this.modificheAbilitateChange.emit(this.modificheAbilitate);
    }
    
    Elimina(value: any) {
        if (!confirm("Sei sicuro di voler eliminare questa categoria?")) 
            return
        
    }
    openModal(targetModal: NgbModal, selected, selectedParent) {
        this.modalService.open(targetModal, {centered: true, backdrop: 'static'});
        this.CategoriaDaModificare = selected ?? {};
        this.CategorieSelezionate = selectedParent ? [selectedParent] : [];
        this.LabelCategoria = selected ? selected.categoria : "";
        this.Ordine = selected ? selected.ordine : 0;
        if(!this.CatFull)
          this.Sources.forEach((source: { nome: string, tipo: string, restroute: string, type?: 'POST' | 'GET', param?: any }) => {
            if (source.type != 'POST') {
              this.apiPaths.ClassicGet(`${source.restroute}/list/list`).subscribe(data => {
                this.CatFull = this.CatFull ?? [];
                this.CatFull = [...this.CatFull, ...this.MapCatTipo(data, source.tipo)];
                console.log("CatFull: ", this.CatFull);
              })
            }
            else
              this.apiPaths.ClassicPost(`${source.restroute}/list/list`, source.param).subscribe(data => {
                this.CatFull = this.CatFull ?? [];
                this.CatFull = [...this.CatFull, ...this.MapCatTipo(data, source.tipo)];
                console.log("CatFull: ", this.CatFull)
              })

          });
      }
      clicked(cat) {
        if (cat && !isNaN(cat.id)) {
          this.sel_cat_id = cat.id;
          console.log(this.sel_cat_id)
          this.Navigate.emit(cat);
        }
      }

      async immaginecambiata(event) {
        const file: Blob = event.target.files[0];
        if (!file.type.includes("image")) {
          this.toastService.warning("Questo formato non è supportato. Inserire solo immagini.", "Attenzione!")
          return;
        }
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.CategoriaDaModificare.immagine = reader?.result?.toString()?.length > 1 ? reader.result.toString() : undefined;
          this.CategoriaDaModificare.file = reader?.result?.toString()?.length > 1 ? event.target.files[0].name : this.CategoriaDaModificare.file;
        };
      }
    
      saveModalButton() {
        console.log("CategoriaDaModificare", this.CategoriaDaModificare)
        if (this.CategoriaDaModificare !== null) {
          const updateData = this.CategoriaDaModificare;
          updateData.categoria = this.LabelCategoria;
          updateData.cat_id = this.CategorieSelezionate != null && this.CategorieSelezionate.length > 0 ? this.CategorieSelezionate[0].id : undefined;
          updateData.ordine = this.Ordine;
          this.Salva(updateData)
        //   if(updateData.id)
        //     this.apiPaths.ClassicPost(`${this.GetCatSource(this.CategoriaDaModificare).restroute}/update`, updateData).subscribe(()=>{
        //         this.closeBtnClick();
        //         this.Save.emit(updateData);
        //     });
        //   else
        //       this.apiPaths.ClassicPost(`${this.GetCatSource(this.CategoriaDaModificare).restroute}/add`, updateData).subscribe(()=>{
        //         this.closeBtnClick();
        //         this.Save.emit(updateData);
        //       });
         
        }
      }
    
      modalClose() {
        this.Refresh.emit();
        this.closeBtnClick()
      }
    
      deleteModalButton() {
        if (confirm("Sei sicuro di voler eliminare questo elemento ?")) {
            const updateData = Object.assign(this.CategoriaDaModificare, {cat_id: this.CategorieSelezionate?.length > 0? this.CategorieSelezionate[0].id : undefined});
            this.Delete(updateData)
        
            
            
        }
      }

      Delete(categoria){
        this.apiPaths.ClassicPost(`${this.GetCatSource(categoria).restroute}/delete`, categoria).subscribe(()=>{
            this.closeBtnClick();
            this.DeleteClick.emit(categoria);
          });
      }
      Salva(categoria){
        console.log("Categoria: ",categoria)
          if(categoria.id)
            this.apiPaths.ClassicPost(`${this.GetCatSource(categoria).restroute}/update`, categoria).subscribe(()=>{
                this.closeBtnClick();
                this.Save.emit(categoria);
            });
          else
              this.apiPaths.ClassicPost(`${this.GetCatSource(categoria).restroute}/add`, categoria).subscribe(()=>{
                this.closeBtnClick();
                this.Save.emit(categoria);
              });
      }
    
      closeBtnClick() {
        this.modalService.dismissAll();
        this.RefreshList();
      }

      RefreshList(){
        //{nome: string, tipo:string, restroute: string}
        if(!(this.Env['CategorieAddon'] && this.Env['CategorieAddon']['Sources']?.length > 0)) return;
        var tipoExist = this.Env['CategorieAddon']['Sources']?.find(source => source.tipo == this.Tipo);
        this.Sources = this.Env['CategorieAddon']['Sources'].filter((source:{nome: string, tipo: string, restroute: string})=> !this.Tipo || this.Tipo == '0'|| this.Tipo == source.tipo || !tipoExist ) ?? [];
        this.Categorie = [];
        this.Sources.forEach((source: { nome: string, tipo: string, restroute: string, type?: 'POST' | 'GET', param?: any }) => {
            if(source.type != 'POST'){
              this.apiPaths.ClassicGet(`${source.restroute}/list`).subscribe(data=>{
                  this.Categorie = this.Categorie ?? [];
                  this.Categorie = [...this.Categorie, ...this.MapCatTipo(data, source.tipo)];
                  console.log("Categorie: ", this.Categorie);
              })
            }
            else
                this.apiPaths.ClassicPost(`${source.restroute}/list`, source.param).subscribe(data=>{
                    this.Categorie = this.Categorie ?? [];
                    this.Categorie = [...this.Categorie, ...this.MapCatTipo(data, source.tipo)];
                    console.log("Categorie: ", this.Categorie)
                })
            
        });
      }


      MapCatTipo(data, tipo){
        return data?.map(x => {
            var cat = Object.assign(x, {listType: tipo});
            cat.figli = this.MapCatTipo(cat.figli, tipo);
            return cat;
        }) ?? [];
        
      }

      GetSource(tipo){
        if(!(this.Env['CategorieAddon'] && this.Env['CategorieAddon']['Sources']?.length > 0)) return null;
        return this.Env['CategorieAddon']['Sources'].find((source:{nome: string, tipo: string, restroute: string})=>  tipo == source.tipo );
      }
      GetCatSource(cat){
        var tipo = cat.listType
        console.log("Cat Type: ", tipo);
        console.log("Cat Source: ", this.GetSource(tipo))
        return this.GetSource(tipo);
      }
  }


@Pipe({
    name: 'CatListPipe',
    pure: false
  })
  export class CatListPipe implements PipeTransform {
    transform(items: any[], filter: string): any {
      return !items? items: items.filter(item => item.listType == filter);
    }
  }
  